import React from 'react'
import GTranslateWidget from "./GTranslateWidget";
import ChatToggle from './ChatToggle';

function Footer() {
  return (
    <>

    {/* <ChatToggle /> */}
    <GTranslateWidget />
    
    
    <div className='footer_section '>
        <div class="container">
           
            <div class="footer_section_2">
               <div class="row">
                  <div class="col-lg-4 col-sm-6">
                    <h2 class="useful_text"></h2>
                    <div class="footer_logo"><img src={`${process.env.PUBLIC_URL}/Assets/images/Logo.png`} /></div>
                     <p class="footer_text">DHK Service Oy, we are dedicated to delivering a comprehensive range of services
                        tailored to meet all your needs in one platform.  </p>
                        <p className='footer_text'>
                        <b>Y-tunnus 3383813-3​</b>
                        </p>
                    
                  </div>
                  <div class="col-lg-3 col-sm-6">
                     <h2 class="useful_text">Quick Link</h2>
                     <div class="footer_menu">
                        <ul>
                           <li><a href="#">About Us</a></li>
                           <li><a href="#">Contact</a></li>
                           <li><a href="#">Quote</a></li>
                           <li><a href="#">Career</a></li>
                           <li><a href="#">Services</a></li>
                           
                        </ul>
                     </div>
                  </div>
                  <div class="col-lg-3 col-sm-6">
                     <h2 class="useful_text">Contact Us</h2>
                     <div class="location_text"><i class="fa fa-phone" > </i><span class="padding_left_15"><a href="#">+358 40 053 6756‬</a></span></div>
                     <div class="location_text"><i class="fa fa-envelope"></i><span class="padding_left_15"><a href="#">info@dhkservice.fi</a></span></div>
                     <div class="location_text"><i class="fa fa-globe"></i><span class="padding_left_15"><a href="#">Myllärintie 6 A 9, 01800 Klaukkala</a></span></div>
                  </div>
                  <div class="col-lg-2 col-sm-6">
                     <h2 class="useful_text">Social Link</h2>
                     <p class="footer_text">You can visit oiur social Link </p>
                     <div class="social_icon">
                        <ul class="list-inline">
                           <li class="list-inline-item">
                              <a href="#"><i class="fab fa-facebook"></i></a>
                           </li>
                           <li class="list-inline-item">
                              <a href="#"><i class="fab fa-twitter"></i></a>
                           </li>
                           <li class="list-inline-item">
                              <a href="#"><i class="fab fa-linkedin"></i></a>
                           </li>
                        </ul>
                     </div>
                  </div>
               </div>
            </div>
            
         </div>


    </div>

    <div class="copyright_section">
        <div class="container">
        <p class="copyright_text"> © 2025 All Rights Reserved DHK. </p>
        </div>
    </div> 
    </>

 

   
  )
}

export default Footer